import { render, staticRenderFns } from "./RenewalNotifications.vue?vue&type=template&id=6cbf9f1a&scoped=true"
import script from "./RenewalNotifications.vue?vue&type=script&lang=js"
export * from "./RenewalNotifications.vue?vue&type=script&lang=js"
import style0 from "./RenewalNotifications.vue?vue&type=style&index=0&id=6cbf9f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf9f1a",
  null
  
)

export default component.exports